// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".-eK1X{display:flex;height:48px;align-items:center;justify-content:space-between;border:1px solid #e2e2e2;margin:0 0 8px;background:#fff;border-radius:8px;color:#767676}.jAHDl{flex:1 0 auto;padding:0 16px;line-height:0;text-decoration:none}.jAHDl,.X5JYW{display:flex;height:100%;align-items:center}.X5JYW{flex:0 0 48px;justify-content:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"podcastPartner": "-eK1X",
	"link": "jAHDl",
	"tooltip": "X5JYW"
};
module.exports = ___CSS_LOADER_EXPORT___;
